import { isDev } from "@/utils/common";

export const isDevelopmentMode = () => {
  return isDev();
};

export function maskValue(value: string | number, visibleLen: number) {
  const str = value.toString();
  if (str.length <= visibleLen) return str;
  return `*${str.slice(-1 * visibleLen)}`;
}
